import { IAmount } from '../..';

export class PricesUtilityHandler {
    static formatAmountsTextWithTaxLabel(amount: IAmount): string {
        return `${amount.amount_formatted} ${amount.tax_label}`;
    }

    static formatAmountsTextDetailWithTaxLabel(amountWithoutTaxes: IAmount, amountWithTaxes: IAmount): string {
        const amountWithoutTaxesDetailWithTaxLabel =
            PricesUtilityHandler.formatAmountsTextWithTaxLabel(amountWithoutTaxes);
        const amountWithTaxesDetailWithTaxLabel = PricesUtilityHandler.formatAmountsTextWithTaxLabel(amountWithTaxes);

        return `${amountWithoutTaxesDetailWithTaxLabel} (${amountWithTaxesDetailWithTaxLabel})`;
    }
}
